"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../../styles/helpers");
const Button_1 = require("../../Button/Button");
const Select_next_1 = require("../../Forms/Select@next");
const Text_1 = require("../../Text/Text");
const Pagination_styles_1 = require("./Pagination.styles");
const PaginationSizeOption = ({ value, children, }) => {
    return (react_1.default.createElement(Select_next_1.SelectItem, { value: value.toString() }, children !== null && children !== void 0 ? children : value));
};
const PaginationSizeSelect = ({ id, children, open, onOpenChange, onPageSizeChange, pageSize, }) => {
    return (react_1.default.createElement(Pagination_styles_1.InlineBlockWrapper, null,
        react_1.default.createElement(helpers_1.VisuallyHidden, { as: "label", htmlFor: id }, "Page size"),
        react_1.default.createElement(Select_next_1.SingleSelect, { id: id, open: open, onOpenChange: onOpenChange, onValueChange: (value) => onPageSizeChange(parseInt(value, 10)), defaultValue: pageSize.toString(), dimension: "medium" }, children)));
};
const PaginationNextButton = ({ onNext }) => {
    return (react_1.default.createElement(Button_1.Button, { type: "button", onClick: onNext, theme: "secondary", dimension: "medium", icon: {
            name: "ArrowTail",
            title: "Next",
            rotation: "right",
        } }));
};
const PaginationPreviousButton = ({ onPrevious, }) => {
    return (react_1.default.createElement(Button_1.Button, { type: "button", onClick: onPrevious, theme: "secondary", dimension: "medium", icon: {
            name: "ArrowTail",
            title: "Previous",
            rotation: "left",
        } }));
};
const PaginationNavigation = ({ children, currentPage, totalPages, }) => {
    return (react_1.default.createElement(Pagination_styles_1.PageNavigationWrapper, null,
        react_1.default.createElement(Text_1.Text, { skinny: true },
            "Page ",
            currentPage,
            " ",
            !!totalPages && react_1.default.createElement(react_1.default.Fragment, null,
                "of ",
                totalPages)),
        react_1.default.createElement(Pagination_styles_1.ButtonWrapper, null, children)));
};
const Pagination = ({ children }) => {
    return react_1.default.createElement(Pagination_styles_1.FlexWrapper, null, children);
};
exports.Pagination = Pagination;
Pagination.SizeOption = PaginationSizeOption;
Pagination.SizeSelect = PaginationSizeSelect;
Pagination.NextButton = PaginationNextButton;
Pagination.PreviousButton = PaginationPreviousButton;
Pagination.Navigation = PaginationNavigation;
//# sourceMappingURL=Pagination.js.map